import { EntityCreateResponse } from '@faro/http-clients';
import { CommandResponse, Epoch, RevisionedCommandResponse, toEpoch } from '@faro/study-designer-model';
import axios from 'axios';
import { Identifiable } from 'faro-common-model';
import { EpochConfigurationQueryParameters } from '../EpochConfiguration/EpochConfigurationClient';
import { RevisionQueryParameter, StudyPathParameter } from '../parameter';

export type EpochPathParameters = StudyPathParameter;
export type EpochQueryParameters = EpochConfigurationQueryParameters & RevisionQueryParameter;

export type IteratedEpoch = Epoch & { minIterations?: number } & { maxIterations?: number };

export const epochClient = {
    list: ({ studyId, ...query }: EpochQueryParameters & EpochPathParameters, signal?: AbortSignal): Promise<Epoch[]> =>
        axios
            .get(`/api/study-designer/studies/${studyId}/epochs`, { signal, params: query })
            .then(response => response.data?.map(toEpoch) ?? []),
    // TODO: when service will be removed, it should use RevisionedCommandResponse<EntityCommandCreateResponse> from @faro/study-designer-model instead of EntityCreateResponse
    create: ({ studyId, ...entity }: Epoch): Promise<EntityCreateResponse> =>
        axios.post(`/api/study-designer/studies/${studyId}/epochs`, entity).then(response => ({
            id: response.data.entityId,
            revision: response.data.revision,
        })),
    createWithCycle: ({ studyId, ...entity }: IteratedEpoch): Promise<EntityCreateResponse> =>
        axios.post(`/api/study-designer/studies/${studyId}/epochs/actions/create`, entity).then(response => ({
            id: response.data.entityId,
            revision: response.data.revision,
        })),
    update: (
        { studyId, ...entity }: Epoch,
        signal?: AbortSignal
    ): Promise<RevisionedCommandResponse<CommandResponse>> =>
        axios
            .put(`/api/study-designer/studies/${studyId}/epochs/${entity.id}`, entity, { signal })
            .then(response => response.data),
    modify: (request: IteratedEpoch & EpochPathParameters): Promise<RevisionedCommandResponse<CommandResponse>> =>
        axios
            .post(`/api/study-designer/studies/${request.studyId}/epochs/${request.id}/actions/modify`, request)
            .then(response => response.data),

    delete: (entity: Identifiable & EpochPathParameters): Promise<RevisionedCommandResponse<CommandResponse>> =>
        axios
            .delete(`/api/study-designer/studies/${entity.studyId}/epochs/${entity.id}`)
            .then(response => response.data),
    get: (query: EpochPathParameters & Identifiable, signal?: AbortSignal): Promise<Epoch> =>
        axios
            .get(`/api/study-designer/studies/${query.studyId}/epochs/${query.id}`, { signal })
            .then(response => response.data),
    map: toEpoch,
};
